<ng-container *transloco="let t">
  <mat-icon
    color="primary"
    [helperTooltip]="orderingState | translate: lang:translationPrefix"
    [helpterTooltipWarn]="true"
  >
    info
  </mat-icon>
</ng-container>
